<template>
  <div id="pers-invest" name="hres8ax-invest" class="content-pers clearfix">
    <div class="col-xs-12 col-md-12">  

      <div class="cal-input-group clearfix">
        <div class="cal-topic clearfix"><!-- {{ labels['HRES8AXC3']['10'] }} --></div>

        <div class="col-xs-12 col-md-3 ">
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding" style="text-align: left">{{ labels['HRES8AXC3']['90'] }}</div>
            </div>
          </div>
          <div class="data-box clearfix">
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <input type="text" class="form-control input-text" id="n_name" name="n_name" v-model="detailInvest.amtD10" style="text-align:right;"/>
              </div>
            </div>
          </div>
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding color-skin" style="text-align: left">{{ labels['HRES8AXC3']['80'] }} 500,000 {{ labels['HRES8AXC3']['110'] }}</div>
            </div>
          </div>
        </div>
  
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC3']['100'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <input type="text" class="form-control input-text" id="n_name" name="n_name" v-model="detailInvest.amtD11" style="text-align:right;"/>
              </div>
            </div>
          </div>
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding color-skin" style="text-align: left">{{ labels['HRES8AXC3']['80'] }} 500,000 {{ labels['HRES8AXC3']['110'] }}</div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC3']['60'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <input type="text" class="form-control input-text" id="n_name" name="n_name" v-model="detailInvest.amtD12" style="text-align:right;"/>
              </div>
            </div>
          </div>
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding color-skin" style="text-align: left">{{ labels['HRES8AXC3']['80'] }} 100,000 {{ labels['HRES8AXC3']['110'] }}</div>
            </div>
          </div>       
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC3']['70'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <input type="text" class="form-control input-text" id="n_name" name="n_name" v-model="detailInvest.amtD13" style="text-align:right;"/>
              </div>
            </div>
          </div>
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding color-skin" style="text-align: left">{{ labels['HRES8AXC3']['80'] }} 200,000 {{ labels['HRES8AXC3']['110'] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'hres8ax-invest',
  props: [ 'labels', 'detailInvest' ]
}
</script>


// WEBPACK FOOTER //
// invest.vue?163f1d53